import { useEffect, useContext } from 'react';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { ComparePqlContext } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/name';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CLOSE_PQL_FRAME = 'CLOSE_FRAME';
const ComparePql = () => {
  const {
    openUpgradeModal
  } = useUpgradeModal('forms-comparison-tool');
  const setIsShowingComparePql = useContext(ComparePqlContext);
  useEffect(() => {
    const setShouldShowPQLFalse = message => {
      if (message.data === CLOSE_PQL_FRAME) {
        setIsShowingComparePql(false);
      }
    };
    window.addEventListener('message', setShouldShowPQLFalse);
    return () => {
      window.removeEventListener('message', setShouldShowPQLFalse);
    };
  }, [setIsShowingComparePql]);
  useEffect(() => {
    openUpgradeModal();
  }, [openUpgradeModal]);
  return /*#__PURE__*/_jsx(_Fragment, {});
};
export default ComparePql;